module.exports = __webpack_public_path__ + "static/assets/f62cd08f444ba039f623f17f641645f5.svg";